import Stack from "react-bootstrap/Stack";

import { useEffect, useState } from "react";
import { useApi, createAPIPOSTPayload } from "../auth";
import { backend_url } from "../constants";
import Tooltip from "./Tooltip";


export default function Dashboard() {
  const [runs, setRuns] = useState([]);
  const { apiFetch } = useApi();
  useEffect(() => {
    apiFetch(backend_url + "/api/get-user-runs/")
      .then((res) => res.json())
      .then((data) => {
        setRuns(data);
      });
  }, []);
  return (
    <div className="dashboard-container">
      <Stack>
        <div className="runs-container">
          <h4>Your Analyses</h4>
          {runs.map((run) => (
            <div className="dashboard-run">
              <Tooltip>
                <div>
                  <span
                    style={{
                      fontVariationSettings:
                        "'FILL' 1, 'wght' 300, 'GRAD' 0, 'opsz' 24",
                    }}
                    className="material-symbols-rounded"
                  >
                    science
                  </span>
                  {run.smiles}
                </div>
              </Tooltip>{" "}
              | <a href={`/result/${run.uuid}`}>{run.name}</a>
            </div>
          ))}
        </div>
      </Stack>
    </div>
  );
}
